export const SERVER_LOCATION = `${process.env.REACT_APP_HOST}/api`

export const DRAWER_WIDTH = 225

export const SESSION_KWIKAPI_TOKEN = "@accessToken"
export const SESSION_USER = "@user"

export const SUPPORT_EMAIL = "suporte@instant.com.br"
export const SUPPORT_FORM_URL = "https://kwik.app.br/form/019ef05d-dec6-7a7d-8baa-100b26f46c7c"
export const DEMO_FORM_URL = "https://kwik.app.br/form/019dabb6-8b22-7f8a-86de-722d4db1a545"

export const KWIK_SCOUT_BEST_PRACTICES_GUIDE_URL = "https://docs.google.com/document/d/e/2PACX-1vQ-Y8-xkmJ-naghEvlius-ywMm32djXShYsDMFTGrOIOVd5vETmWz8VFLN14c5zJSGeCWvjOBix_LLS/pub"
